import { useCallback, useState } from "react";
import { Outlet } from "react-router-dom";
import { Sidebar, Topbar, BottomTabBar } from "@/components/system";
import { PWAUpdateBanner } from "@/components/system/PWAUpdateBanner";
import { CaptureSheet } from "@/components/capture/CaptureSheet";
import { useCaptureShortcut } from "@/hooks/use-capture-shortcut";
import { useTasksShortcut } from "@/hooks/use-tasks-shortcut";

/**
 * App layout — desktop = sidebar + topbar; mobile = topbar (mini) + bottom tabs.
 * Layout switching is pure CSS (media queries) so SSR + first paint are stable.
 */

export function AppShell() {
  const [captureOpen, setCaptureOpen] = useState(false);
  const openCapture = useCallback(() => setCaptureOpen(true), []);
  useCaptureShortcut(openCapture);
  useTasksShortcut();

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "var(--bg)",
        color: "var(--fg)",
      }}
    >
      <div className="haus-sidebar-wrap">
        <Sidebar />
      </div>

      <div
        className="haus-shell-main"
        style={{
          marginLeft: "var(--sidebar-w)",
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Topbar />
        <main
          id="main"
          style={{
            flex: 1,
            maxWidth: "var(--main-max)",
            width: "100%",
            margin: "0 auto",
            padding: "var(--space-10) var(--space-8) var(--space-16)",
          }}
        >
          <Outlet />
        </main>
      </div>

      <div className="haus-bottombar-wrap">
        <BottomTabBar />
      </div>

      <PWAUpdateBanner />
      <CaptureSheet open={captureOpen} onClose={() => setCaptureOpen(false)} />

      <style>{`
        .haus-bottombar-wrap { display: none; }
        @media (max-width: 1023px) {
          .haus-sidebar-wrap { display: none; }
          .haus-shell-main { margin-left: 0 !important; }
          .haus-bottombar-wrap { display: block; }
        }
        @media (max-width: 767px) {
          .haus-shell-main main {
            padding: var(--space-4) var(--space-4) calc(var(--bottomtab-h) + var(--space-8)) !important;
          }
        }
        @media (min-width: 768px) and (max-width: 1023px) {
          .haus-shell-main main {
            padding-bottom: calc(var(--bottomtab-h) + var(--space-10)) !important;
          }
        }
      `}</style>
    </div>
  );
}
